{
  "actions": {
    "cancel": "Cancel",
    "close": "Close",
    "confirm": "Confirm",
    "delete": "Delete",
    "retry": "Retry",
    "save": "Save"
  },
  "apiError": {
    "description": "Please try again. If it keeps happening, contact support.",
    "restoreDescription": "Check your connection and try again.",
    "restoreTitle": "We couldn't restore your session",
    "retry": "Try again",
    "title": "We couldn't load this"
  },
  "theme": {
    "dark": "Dark",
    "label": "Theme: {{choice}}",
    "light": "Light",
    "system": "System"
  },
  "errorBoundary": {
    "updateAvailable": "A new update is available. Please try refreshing the page.",
    "refresh": "Refresh",
    "crashed": "This page hit an unexpected error.",
    "reload": "Reload",
    "returnToStreams": "Return to streams"
  }
}
